import { BookOpen as BookOpenIcon, Download as DownloadIcon } from 'lucide-react';
import React from 'react';
import { useI18n } from '../../i18n/I18nProvider';

const WhereToBuy: React.FC<{ amazonUrl: string; leanpubUrl: string }> = ({ amazonUrl, leanpubUrl }) => {
  const { t } = useI18n();

  return (
    <section id='donde-comprar' className='bg-yellow-50 py-16'>
      <div className='max-w-3xl mx-auto px-8 text-center'>
        <h2 className='text-3xl md:text-4xl font-bold text-gray-800 mb-6'>{t.sections.dondeComprar.title}</h2>
        <p className='text-lg text-gray-700 mb-8'>{t.sections.dondeComprar.description}</p>
        <div className='flex flex-col md:flex-row gap-6 justify-center items-center'>
          <a
            href={amazonUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='inline-block bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500 text-white font-semibold py-4 px-10 rounded-lg shadow text-center transition flex items-center justify-center gap-3 text-xl'
          >
            <DownloadIcon className='h-6 w-6' />
            {t.sections.dondeComprar.button}
          </a>
          <a
            href={leanpubUrl}
            target='_blank'
            rel='noopener noreferrer'
            className='inline-block bg-gradient-to-r from-blue-600 to-blue-400 hover:from-blue-700 hover:to-blue-500 text-white font-semibold py-4 px-10 rounded-lg shadow text-center transition flex items-center justify-center gap-3 text-xl'
          >
            <BookOpenIcon className='h-6 w-6' />
            {t.sections.dondeComprar.buttonLeanpub || 'Comprar en Leanpub'}
          </a>
        </div>
      </div>
    </section>
  );
};

export default WhereToBuy; 